import { PacksClient } from '../types'

export const importPack = (base: PacksClient) => (upload_token: string, to_template: boolean = false, from_template: boolean = false) => 
  base.requester.post<any>(`/import`, { upload_token, to_template, from_template }, { withCredentials: true })
